import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { DocumentModalType } from 'src/lib/repository/document/document.api';
import { AuthService } from 'src/lib/auth/auth.service';
import { LanguageService } from 'src/lib/services/language.service';

export const documentTitleResolver: ResolveFn<string> = (route) => {
  const translateService = inject(TranslateService);

  const authService = inject(AuthService);
  const { account } = authService;

  const languageService = inject(LanguageService);
  languageService.init(account.brand);

  if (route.firstChild) {
    let key = '';
    switch (route.firstChild.data['type'] as DocumentModalType) {
      case 'booking-estimate':
      case 'booking-estimate-fit':
        key = 'document.estimate';
        break;
      case 'booking-confirmation':
        key = 'document.confirmation';
        break;
      case 'invoice':
      case 'invoice2':
        key = 'document.invoice';
        break;
      case 'arrangement':
        key = 'document.arrangement';
        break;
      case 'final-arrangement':
        key = 'document.finalArrangement';
        break;
      case 'schedule':
        key = 'document.schedule';
        break;
      case 'order':
        key = 'document.order';
        break;
      case 'hotel-confirmation':
        key = 'hotelReservationConfirmation';
        break;
      case 'hotel-request':
        key = 'hotelReservationRequest';
        break;
      case 'restaurant-request':
        key = 'restaurantReservationRequest';
        break;
      case 'pickup-request':
        key = 'pickupReservationRequest';
        break;
      case 'room-booking-application':
      case 'room-booking-application-form' as DocumentModalType:
        key = 'document.room.reservation';
        break;
      case 'room-change-application':
      case 'room-change-application-form' as DocumentModalType:
        key = 'document.room.change';
        break;
      case 'room-cancel-application':
      case 'room-cancel-application-form' as DocumentModalType:
        key = 'document.room.cancellation';
        break;
      case 'room-final-confirmation':
      case 'room-final-confirmation-form' as DocumentModalType:
        key = 'document.room.finalConfirm';
        break;
      default:
    }

    if (key) {
      return translateService.currentLoader
        .getTranslation(translateService.getCurrentLang())
        .pipe(map((translation) => translation[key] as string));
    }
  }

  return translateService.currentLoader
    .getTranslation(translateService.getCurrentLang())
    .pipe(map((translation) => translation['document._'] as string));
};
